import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const amountPickerDefaultVariants = {
  "size": "large"
}
const amountPickerCompoundVariants = []

const amountPickerSlotNames = [
  [
    "root",
    "AmountPicker__root"
  ],
  [
    "buttons",
    "AmountPicker__buttons"
  ],
  [
    "input",
    "AmountPicker__input"
  ]
]
const amountPickerSlotFns = /* @__PURE__ */ amountPickerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, amountPickerDefaultVariants, getSlotCompoundVariant(amountPickerCompoundVariants, slotName))])

const amountPickerFn = memo((props = {}) => {
  return Object.fromEntries(amountPickerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const amountPickerVariantKeys = [
  "error",
  "size"
]
const getVariantProps = (variants) => ({ ...amountPickerDefaultVariants, ...compact(variants) })

export const amountPicker = /* @__PURE__ */ Object.assign(amountPickerFn, {
  __recipe__: false,
  __name__: 'amountPicker',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: amountPickerVariantKeys,
  variantMap: {
  "error": [
    "true"
  ],
  "size": [
    "large",
    "medium"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, amountPickerVariantKeys)
  },
  getVariantProps
})